// import BankAccount from '@/views/bank/BankAccount'
// import NewBankAccount from '@/views/bank/NewBankAccount'
const NewBankAccount = () => import('@/views/bank/NewBankAccount');
const BankAccount = () => import('@/views/bank/BankAccount');
import getWhiteLabel from '@/utils/getWhiteLabel';

import Index from '@/views/Index.vue';

const bankRouter = {
    path: '/bank',
    component: Index,
    name: 'client/bank',
    meta: {
        requiresAuth: true
    },
    children: [{
            name: 'client/bank',
            path: '/',
            component: BankAccount,
            meta: {
                title: `${getWhiteLabel()} - Contas Correntes`,
                requiresAuth: true
            },
        },
        {
            name: 'client/bank',
            path: 'new',
            component: NewBankAccount,
            meta: {
                title: `${getWhiteLabel()} - Contas Correntes`,
                requiresAuth: true
            },
        },
        {
            name: 'client/bank',
            path: 'edit/:id',
            component: NewBankAccount,
            meta: {
                title: `${getWhiteLabel()} - Contas Correntes`,
                requiresAuth: true
            },
        },
    ]

}

export default bankRouter;